import { useState } from "react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ChevronDown, ChevronUp } from "lucide-react";
import {
  Key,
  Users,
  Gamepad2,
  Settings,
  Clock,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Shield,
  HelpCircle
} from "lucide-react";
import { type FAQItem } from "@/data/faqData";

const iconMap = {
  Key,
  Users,
  Gamepad2,
  Settings,
  Clock,
  AlertTriangle,
  CheckCircle,
  XCircle,
  Shield,
  HelpCircle
};

interface FAQItemProps {
  faq: FAQItem;
  isExpanded: boolean;
  onToggle: () => void;
}

export const FAQItemComponent = ({ faq, isExpanded, onToggle }: FAQItemProps) => {
  const IconComponent = iconMap[faq.icon as keyof typeof iconMap] || HelpCircle;

  return (
    <Card id={faq.id} className="overflow-hidden rounded-custom-paddings hover:bg-muted/50">
      <button
        onClick={onToggle}
        className="w-full p-6 text-left transition-colors rounded-custom-paddings"
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4 flex-1">
            <div className="text-primary">
              <IconComponent className="w-5 h-5" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-lg font-semibold">{faq.question}</h3>
                <Badge variant="secondary" className="text-xs">
                  {faq.category}
                </Badge>
              </div>
            </div>
          </div>
          <div className="text-muted-foreground">
            {isExpanded ? (
              <ChevronUp className="w-5 h-5" />
            ) : (
              <ChevronDown className="w-5 h-5" />
            )}
          </div>
        </div>
      </button>

      {isExpanded && (
        <div className="px-6 pb-6 bg-muted/20 rounded-custom-paddings mt-2">
          <div className="p-4">
            <p
              className="text-muted-foreground leading-relaxed"
              dangerouslySetInnerHTML={{ __html: faq.answer }}
            />
          </div>
        </div>
      )}
    </Card>
  );
};
